module.exports = __webpack_public_path__ + "img/UTWASA.de01e436.png";